/**
 * @generated SignedSource<<e869c6a5f25c54abe33629b04b2801e9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileAvatar_profile$data = {
  readonly headshot: {
    readonly storageObject: {
      readonly blurhash: string | null | undefined;
      readonly bucket: string | null | undefined;
      readonly key: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly name: string;
  readonly " $fragmentType": "ProfileAvatar_profile";
};
export type ProfileAvatar_profile$key = {
  readonly " $data"?: ProfileAvatar_profile$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileAvatar_profile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileAvatar_profile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Photo",
      "kind": "LinkedField",
      "name": "headshot",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StorageObject",
          "kind": "LinkedField",
          "name": "storageObject",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "blurhash",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "bucket",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "key",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Profile",
  "abstractKey": null
};

(node as any).hash = "9a206e633b27999505c754b96383a189";

export default node;
